const styles = theme => ({
  app: {
    height: "100vh"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/App/styles.js